import { Fragment, MutableRefObject } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { GalleryTitle, Href, ImageGalleryTitle } from "../../../../Constants/Constants";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const GalleryGridContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={GalleryTitle} parent={GalleryTitle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={ImageGalleryTitle} />
              <CardBody className="gallery my-gallery">
                <Row className="g-3">
                  <Gallery>
                    {dynamicNumber(12).map((item, index) => (
                      <Col xl="3" md="4" xs="6" key={index}>
                        <figure>
                          <Item original={dynamicImage(`lightgallry/0${item}.jpg`)} width="1300" height="800">
                            {({ ref, open }) => (
                              <Link to={Href} onClick={open}>
                                <img className="img-thumbnail" ref={ref as unknown as MutableRefObject<HTMLImageElement>} src={dynamicImage(`lightgallry/0${item}.jpg`)} alt="Image_description" />
                              </Link>
                            )}
                          </Item>
                        </figure>
                      </Col>
                    ))}
                  </Gallery>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GalleryGridContainer;
